import styled from 'styled-components';

export const ResendContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 32px;
`;

export const DescriptionContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 48px;
	max-width: 400px;
	text-align: center;
`;

export const SendIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	margin-top: 48px;
`;

export const CheckYourEmailBanner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 80px;
`;
